"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var state_1 = __importDefault(require("./state"));
var memorize_1 = __importStar(require("../models/memorize"));
var memorize_container_1 = __importDefault(require("../views/memorize-container"));
var navigation_button_1 = __importStar(require("../views/navigation-button"));
var title_container_1 = __importDefault(require("../views/title-container"));
var game_area_1 = require("../utilities/game-area");
var color_1 = require("../utilities/color");
var stack_container_1 = __importStar(require("../views/stack-container"));
var calculator_1 = require("../models/calculator");
var i18next_1 = __importDefault(require("i18next"));
var MemorizeState = /** @class */ (function (_super) {
    __extends(MemorizeState, _super);
    function MemorizeState(app, client, dragonContainer) {
        var _this = _super.call(this) || this;
        _this._app = app;
        _this._client = client;
        _this._dragonContainer = dragonContainer;
        _this._memorize = new memorize_1.default();
        _this._memorize.stateListener = _this.onState.bind(_this);
        return _this;
    }
    Object.defineProperty(MemorizeState.prototype, "memorizeContainer", {
        get: function () {
            if (!this._memorizeContainer) {
                this._memorizeContainer = new memorize_container_1.default(this._app.loader.resources);
                this._memorizeContainer.scale.set(0.5);
                this._memorizeContainer.position.set(game_area_1.GAME_WIDTH * 0.5, game_area_1.GAME_HEIGHT * 0.5);
                this._memorizeContainer.on("hitbox", this.onHitbox.bind(this));
            }
            return this._memorizeContainer;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MemorizeState.prototype, "backButton", {
        get: function () {
            var _this = this;
            if (!this._backButton) {
                this._backButton = new navigation_button_1.default(this._app.loader.resources.ui.textures, navigation_button_1.NAVIGATION_BUTTON_TYPE.BACK, function () {
                    _this.stateMachine.pop();
                });
                this._backButton.position.set(game_area_1.GAME_SAFE_AREA.left + 12, game_area_1.GAME_SAFE_AREA.top + 12);
            }
            return this._backButton;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MemorizeState.prototype, "titleContainer", {
        get: function () {
            if (!this._titleContainer) {
                this._titleContainer = new title_container_1.default(this._app.loader.resources.ui.textures);
                this._titleContainer.setText(i18next_1.default.t("memorize_title"));
                this._titleContainer.position.set((game_area_1.GAME_WIDTH - this._titleContainer.width) * 0.5, game_area_1.GAME_SAFE_AREA.top + 12);
            }
            return this._titleContainer;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MemorizeState.prototype, "titleLabel", {
        get: function () {
            if (!this._titleLabel) {
                this._titleLabel = new PIXI.Text("");
                this._titleLabel.style = {
                    fontFamily: "Arial",
                    fontWeight: "bold",
                    align: "center",
                    fontSize: 35,
                    fill: color_1.COLOR.WHITE
                };
            }
            return this._titleLabel;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MemorizeState.prototype, "tipLabel", {
        get: function () {
            if (!this._tipLabel) {
                this._tipLabel = new PIXI.Text("");
                this._tipLabel.style = {
                    fontFamily: "Arial",
                    fontSize: 21,
                    fill: color_1.COLOR.GREEN
                };
            }
            return this._tipLabel;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MemorizeState.prototype, "stackContainer", {
        get: function () {
            if (!this._stackContainer) {
                this._stackContainer = new stack_container_1.default([
                    this.titleLabel,
                    this.tipLabel
                ], {
                    axis: stack_container_1.STACK_CONTAINER_AXIS.VERTICAL,
                    alignment: stack_container_1.STACK_CONTAINER_ALIGNMENT.CENTER,
                    spacing: 6,
                    minWidth: game_area_1.GAME_WIDTH
                });
                this._stackContainer.position.set(0, game_area_1.GAME_SAFE_AREA.bottom - this._stackContainer.height - 10);
            }
            return this._stackContainer;
        },
        enumerable: false,
        configurable: true
    });
    MemorizeState.prototype.didEnterFrom = function (previousState) {
        _super.prototype.didEnterFrom.call(this, previousState);
        this._app.stage.addChild(this.memorizeContainer);
        this._app.stage.addChild(this.stackContainer);
        this._app.stage.addChild(this.backButton);
        this._app.stage.addChild(this.titleContainer);
        this._app.stage.interactive = true;
        this._app.stage.on("pointerdown", this._memorize.start.bind(this._memorize));
        this._dragonContainer.setIdleAnimation();
        this.memorizeContainer.dragonSlot.addChild(this._dragonContainer);
        this._memorize.clear();
        this._client.sendEvent("memorize_entered");
    };
    MemorizeState.prototype.willExitTo = function (nextState) {
        _super.prototype.willExitTo.call(this, nextState);
        this._app.stage.removeChild(this.memorizeContainer);
        this._app.stage.removeChild(this.stackContainer);
        this._app.stage.removeChild(this.backButton);
        this._app.stage.removeChild(this.titleContainer);
        this._app.stage.interactive = false;
        this._app.stage.off("pointerdown");
        this.memorizeContainer.dragonSlot.removeChild(this._dragonContainer);
    };
    MemorizeState.prototype.update = function (deltaTime) {
        this.memorizeContainer.spine.update(deltaTime / 1000);
    };
    MemorizeState.prototype.onHitbox = function (hitbox) {
        var element = memorize_1.MEMORIZE_ELEMENT[hitbox.name.toUpperCase()];
        if (!element) {
            return;
        }
        this.memorizeContainer.addFlashAnimation(hitbox.name);
        this._memorize.answer(element);
    };
    MemorizeState.prototype.onState = function (state) {
        var _this = this;
        switch (state) {
            case memorize_1.MEMORIZE_STATE.NEW_GAME:
                this._app.stage.interactive = true;
                this.memorizeContainer.spine.interactive = false;
                this.memorizeContainer.clearAnimations();
                this.titleLabel.text = i18next_1.default.t("memorize_caption");
                this.tipLabel.text = i18next_1.default.t("memorize_hint");
                this.stackContainer.layoutChildren();
                break;
            case memorize_1.MEMORIZE_STATE.LEVEL_START:
                this._app.stage.interactive = false;
                this.titleLabel.text = this._memorize.score.toFixed();
                this.tipLabel.text = this._memorize.message;
                this.stackContainer.layoutChildren();
                this.memorizeContainer.spine.interactive = false;
                this.memorizeContainer.addEmptyAnimation(1.75);
                for (var i = 0; i < this._memorize.length; i++) {
                    var colorName = this._memorize.elementAt(i).valueOf();
                    this.memorizeContainer.addFlashAnimation(colorName);
                }
                this.memorizeContainer.addEmptyAnimation(0, function () {
                    _this.memorizeContainer.spine.interactive = true;
                });
                break;
            case memorize_1.MEMORIZE_STATE.GAME_OVER:
                var rewardScale = Math.min(this._memorize.score / calculator_1.MEMORIZE_MAX_REWARDED_SCORE, 1);
                var points = calculator_1.MEMORIZE_XP * rewardScale;
                this._app.stage.interactive = true;
                this.memorizeContainer.spine.interactive = false;
                this.memorizeContainer.setGameOverAnimation();
                this.titleLabel.text = this._memorize.score.toFixed();
                this.tipLabel.text = i18next_1.default.t("memorize_finish_hint")
                    .replace("[points]", points.toFixed());
                this.stackContainer.layoutChildren();
                this._client.adjustMeters({
                    calmness: 0,
                    nutrition: 0,
                    hygiene: 0,
                    energy: 50 * rewardScale
                });
                this._client.award(points);
                this._client.synchronize();
                this._client.sendEvent("memorize_finished", {
                    score: this._memorize.score
                });
                break;
        }
    };
    return MemorizeState;
}(state_1.default));
exports.default = MemorizeState;
